export enum CAMPAIGNS_ASSIGNING_METHODS {
  CHANNEL_WISE = 'CW',
  DESIGNATION_WISE = 'DW',
  AGENT_CODE_WISE = 'AC',
}

export enum CAMPAIGNS_STATUS {
  ACTIVE = 'A',
  DE_ACTIVE = 'D',
}

export enum BULK_FIELDS_CAMPAIGN {
  NAME = 'Name',
  CONTACT_NUMBER = 'Contact Number',
}

export enum ERROR_TYPES {
  REQUIRED = 'required',
  PHONE_NUMBER_ISSUE = 'phone_number_issue',
  NAME_ISSUE = 'name_issue',
  NAME_IS_REQUIRED = 'name_is_required',
}
export enum CAMPAIGN_REPORT_TYPE {
  IS_LEAD_AGEING = 'is_lead_ageing',
  IS_CAMPAIGN_PERFORMANCE = 'is_campaign_performance',
}
export enum CAMPAIGN_REPORT_DOWNLOAD_TYPE {
  CSV = 'csv',
  EXCEL = 'excel',
}
